const smoothScrollingOnPageAnchors = () => {
  $("a[href^='#']").on("click", (e) => {
    const speed = 500;
    const href = $(e.currentTarget).attr("href");
    const target = href === "#" || href === "" ? $("html") : $(href);
    const position = target.offset().top;

    $("html, body").animate({ scrollTop: position }, speed, "swing");
    // return false; //スマホナビ内でのクリックイベントが無効化されないように変更
    e.preventDefault();
  });
};

export default smoothScrollingOnPageAnchors;